import React from 'react';
import createReactClass from 'create-react-class';
import Formsy from 'formsy-react';
import { ComponentMixin } from 'formsy-react-components';

var AdornedInput = createReactClass({
  mixins: [Formsy.Mixin, ComponentMixin],

  getDefaultProps() {
    return {
      label: '',
      rowClassName: '',
      labelClassName: '',
      elementWrapperClassName: '',
      required: false,
      hasErrors: false,
      fakeLabel: false
    };
  },

  changeValue(event) {
    var value = event.currentTarget.value;
    this.setValue(value);
    this.props.onChange(this.props.name, value);
  },

  render(){
    var cssClasses = {
      row: ['form-group'],
      elementWrapper: []
    };

    if (this.showErrors()) {
      cssClasses.row.push('has-error');
      cssClasses.row.push('has-feedback');
    }

    var element = this.renderElement();

    if (this.props.addonBefore) {
      element = this.renderInputGroup(element);
    }

    return (
      <div className={cssClasses.row.join(' ')}>
        {element}
      </div>
    );
  },

  renderElement() {
    var className = 'form-control';
    if (['range'].indexOf(this.props.type) !== -1) {
      className = null;
    }

    return (
        <input
          className={className}
          {...this.props}
          id={this.getId()}
          label={null}
          value={this.getValue()}
          onChange={this.changeValue}
          disabled={this.isFormDisabled() || this.props.disabled}
        />
    );
  },

  renderInputGroup(element) {
    return (
     <div className="input-group">
         {this.renderAddon(this.props.addonBefore)}
         {element}
         {this.renderAddon(this.props.addonAfter)}
     </div>
    );
  },

  renderAddon(addon) {
    if (!addon) {
      return false;
    }
    return (
      <span className="input-group-addon">{addon}</span>
    );
  }
});

export default AdornedInput;



// WEBPACK FOOTER //
// ./src/components/common/Forms/AdornedInput.js